import React from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import TappableLink from '../../../components/TappableLink';
import RaisedButtonLink from '../../../components/RaisedButtonLink';
import './DashboardGame.css';

const DashboardGame = ({ game, gameDetailsLink, startCodingLink }) => (
  <div className="dashboard-game">
    <h1 className="dashboard-game__date">
      {moment(game.get('date')).format('dddd, MMM Do')}
    </h1>
    <h3 className="dashboard-game__time">
      {moment(game.get('date')).format('LT')}
    </h3>
    <h2 className="dashboard-game__opposing-team">
      <TappableLink to={gameDetailsLink}>
        vs. {game.get('opposingTeam')}
      </TappableLink>
    </h2>

    <nav>
      <RaisedButtonLink to={startCodingLink} label="Start Coding" />
    </nav>
  </div>
);

DashboardGame.propTypes = {
  game: PropTypes.object.isRequired,
  gameDetailsLink: PropTypes.string.isRequired,
  startCodingLink: PropTypes.string.isRequired
};

export default DashboardGame;



// WEBPACK FOOTER //
// ./src/routes/home/components/DashboardGame.js